import type React from 'react';
import { useNavigate } from 'react-router';

import { addNotification } from 'notifications';
import { Button, OTPInput } from 'ui';
import { OTP_CODE_LENGTH } from 'constants/otp';

import classes from './ConfirmPassword.module.scss';
import { verificationCodeSchema } from './schema';

import { useForm } from 'form';

export const ConfirmPassword: React.FC = () => {
  const { values, changeHandlers, validate } = useForm(
    {
      otp: '',
    },
    { schema: verificationCodeSchema },
  );

  const navigate = useNavigate();

  const handleGetCode: React.FormEventHandler = async (e) => {
    e.preventDefault();
    const isValid = await validate();

    if (!isValid) {
      addNotification('Заполните все поля', 'warning');
      return;
    }
    addNotification('Код подтвержден', 'success');
    navigate('/');
  };

  return (
    <section className={classes.wrapper}>
      <main className={classes.container}>
        <form onSubmit={handleGetCode}>
          <h1 className={classes.title}>Подтверждение пароля</h1>
          <OTPInput length={OTP_CODE_LENGTH} value={values.otp} onChange={changeHandlers.otp} />
          <div className={classes.wrapperButton}>
            <Button
              type='submit'
              variant='filled'
              shape='brick'
              color='primary'
              widthFullSize
            >
              Получить код
            </Button>
          </div>
        </form>
      </main>
    </section>
  );
};
